import { render, staticRenderFns } from "./settingService.vue?vue&type=template&id=3d9dd45b"
import script from "./settingService.vue?vue&type=script&lang=js"
export * from "./settingService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports